import API from './../api';

export default {

    namespaced: true,

    state() {
        return {
            currentEmbeddedPage: null,
            embeddedPages: [],
        };
    },

    getters: {
        currentEmbeddedPage: (state) => state.currentEmbeddedPage,
        embeddedPages: (state) => state.embeddedPages,
        embeddedPageByID: (state) => (id) => state.embeddedPages.find(item => item.id === id),
    },

    mutations: {
        assignCurrentEmbeddedPage(state, { id }) {
            state.currentEmbeddedPage = state.embeddedPages.find(item => item.id === id);
        },
        assignFirstCurrentEmbeddedPage(state) {
            state.currentEmbeddedPage = state.embeddedPages[0];
        },
        gotEmbeddedPages(state, response) {
            state.embeddedPages = response.data || [];
        },
        createdEmbeddedPage(state, response) {
            state.embeddedPages = state.embeddedPages.concat([response.data]);
            state.currentEmbeddedPage = response.data;
        },
        deletedEmbeddedPage(state, { id }) {
            state.embeddedPages = state.embeddedPages.filter(item => item.id !== id);
        },
        updatedEmbeddedPage(state, response) {
            state.embeddedPages = state.embeddedPages
                .map(item => item.id === response.data.id ? response.data : item);
            if (state.currentEmbeddedPage.id === response.data.id) {
                state.currentEmbeddedPage = response.data;
            }
        }
    },

    actions: {
        async fetchEmbeddedPages({ commit }) {
            commit('gotEmbeddedPages', await API.get('/app/embedded-page/embedded-page/'));
        },
        async createEmbeddedPage({ commit }) {
            commit(
                'createdEmbeddedPage',
                await API.post('/app/embedded-page/embedded-page/')
            );
        },
        async deleteEmbeddedPage({ commit, state }, { id }) {
            await API.delete(`/app/embedded-page/embedded-page/${id}/`);
            commit('deletedEmbeddedPage', { id });
            if (state.currentEmbeddedPage.id === id) {
                commit('assignFirstCurrentEmbeddedPage');
            }
        },
        async updateEmbeddedPage({ commit }, { id, ...payload }) {
            commit(
                'updatedEmbeddedPage',
                await API.patch(`/app/embedded-page/embedded-page/${id}/`, payload)
            );
        },
        async enableDisableEmbeddedPageProperty({ commit }, { id, ...payload }) {
            commit(
                'updatedEmbeddedPage',
                await API.post(`/app/embedded-page/embedded-page/${id}/enable-disable-property/`, payload)
            );
        },
        async enableDisableEmbeddedPagePropertiesArea({ commit }, { id, ...payload }) {
            commit(
                'updatedEmbeddedPage',
                await API.post(`/app/embedded-page/embedded-page/${id}/enable-disable-properties-area/`, payload)
            );
        },
        async enableDisableEmbeddedPagePropertyMarketingTitle({ commit }, { id, ...payload }) {
            commit(
                'updatedEmbeddedPage',
                await API.post(`/app/embedded-page/embedded-page/${id}/enable-disable-property-marketing-title/`, payload)
            );
        },
    },

};
